import React from 'react'
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from '../../Context/useAuth';
import { useForm } from 'react-hook-form';

type Props = {}

type LoginFormsInputs = {
  userName: string;
  password: string;
}

const validation = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});


const LoginPage = (props: Props) => {
  const { loginUser } = useAuth();
  const { 
    register, 
    handleSubmit, 
    formState: { errors }, 
  } = useForm<LoginFormsInputs>({resolver: yupResolver(validation),});

  const handleLogin = (form: LoginFormsInputs) => {
    loginUser( form.userName, form.password );
  };

  return (
    <section className="bg-#97c0db dark:bg-gray-900">
    <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <div className="w-full bg-slate-500 rounded-lg shadow dark:border md:mb-20 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="bg-#97c0db text-xl font-oldEnglish font-bold leading-tight tracking-tight text-slate-300 md:text-2xl dark:text-white">
          Pray thee, enter thy accounts. 🎭👑
          </h1>
          <form
            className="bg-#97c0db space-y-4 md:space-y-6"
            onSubmit={handleSubmit(handleLogin)}
          >
            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-oldEnglish font-medium text-slate-100 dark:text-white"
              >
                Thy username
              </label>
              <input
                type="text"
                id="username"
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Username"
                {...register("userName")}
              />
              {errors.userName ? (
                <p className="text-white">{errors.userName.message}</p>
              ) : (
                ""
              )}
            </div>
            <div>
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-oldEnglish font-medium text-slate-100 dark:text-white"
              >
                Pray thee, enter thy password correctly 🎟⚔
              </label>
              <input
                type="password"
                id="password"
                placeholder="••••••••"
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                {...register("password")}
              />
              {errors.password ? (
                <p className="text-white">{errors.password.message}</p>
              ) : (
                ""
              )}
            </div>
            <div className="flex items-center justify-between">
              <a
                href="#"
                className="text-sm text-slate-100 font-oldEnglish font-medium text-primary-600 hover:underline dark:text-primary-500"
              >
                Shouldst thou have forgotten thy sacred passphrase, fear not, for thou mayest recover it here. 🔑
              </a>
            </div>
            <button
              type="submit"
              className="w-full text-slate-800 font-oldEnglish bg-cyan-300 hover:bg-primary-700 focus:ring-4 
              focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 
              text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
            >
              Sign in
            </button>
            <p className="text-sm font-oldEnglish font-light text-slate-100 dark:text-gray-400">
              Don’t have an account yet?{" "}
              <a
                href="register"
                className="font-medium font-oldEnglish text-primary-600 hover:underline dark:text-primary-500"
              >
                Enscribe thyself unto our rolls. 🖋 ️
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
  )
}
export default LoginPage